import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function DataUsagePolicy() {
  return <section id="datausagepolicy" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-4xl">
        <Card className="border-border shadow-sm">
          <CardHeader className="pb-8">
            <CardTitle className="text-3xl md:text-4xl font-bold font-default text-foreground">
              Data Usage & Processing
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-8 font-sans">
            <div>
              <h3 className="text-2xl font-semibold font-default text-foreground mb-4">
                How We Use Your Information
              </h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">
                We use your personal information to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-6 leading-relaxed">
                <li>Provide quotations and estimates</li>
                <li>Supply, install, service, maintain, and repair air conditioning systems</li>
                <li>Manage customer accounts</li>
                <li>Process payments and invoices</li>
                <li>Respond to enquiries</li>
                <li>Schedule appointments and site visits</li>
                <li>Meet legal and regulatory obligations</li>
                <li>Improve our services and website</li>
                <li>Send service-related communications</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed">
                Where required by law, we will obtain your consent before sending marketing communications.
              </p>
            </div>

            <Separator className="my-8" />

            <div>
              <h3 className="text-2xl font-semibold font-default text-foreground mb-4">
                Lawful Basis for Processing
              </h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">
                We process personal data under one or more of the following lawful bases:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground leading-relaxed">
                <li>Performance of a contract</li>
                <li>Compliance with legal obligations</li>
                <li>Legitimate business interests</li>
                <li>Consent {"(where required)"}</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}